module.exports = __webpack_public_path__ + "img/epr-price_medium.4a30807d.jpg";